import CaptionToggleButton from "@components/controls/CaptionToggleButton";
import toggleSignature from "@core-ui/toggleSignature";
import t from "@ext/localization/locale/translate";
import GalleryAddImagesButton from "@ext/markdown/elements/gallery/edit/components/GalleryAddImagesButton";
import GalleryViewActions from "@ext/markdown/elements/gallery/edit/components/GalleryViewActions";
import ungroupGallery from "@ext/markdown/elements/gallery/edit/logic/ungroupGallery";
import type { Editor } from "@tiptap/core";
import type { Node } from "@tiptap/pm/model";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";
import type { Dispatch, RefObject, SetStateAction } from "react";

interface GalleryActionsProps {
	editor: Editor;
	node: Node;
	getPos: () => number;
	hasSignature: boolean;
	setHasSignature: Dispatch<SetStateAction<boolean>>;
	signatureRef: RefObject<HTMLInputElement>;
	updateAttributes: (attrs: Record<string, unknown>) => void;
}

const GalleryActions = (props: GalleryActionsProps) => {
	const { editor, node, getPos, hasSignature, setHasSignature, signatureRef, updateAttributes } = props;
	const signatureTooltip = t("editor.gallery.caption");
	const ungroupTooltip = t("editor.gallery.ungroup");

	const ungroup = () => {
		if (!editor || editor.isDestroyed) return;
		editor.view.dispatch(ungroupGallery(editor.state.tr, getPos()));
	};

	return (
		<>
			<GalleryViewActions onChange={(view) => updateAttributes({ view })} view={node.attrs.view} />
			<GalleryAddImagesButton editor={editor} getPos={getPos} />
			<CaptionToggleButton
				active={hasSignature}
				caption={node.attrs.title}
				onToggle={() =>
					setHasSignature((prev) => toggleSignature(prev, signatureRef.current, updateAttributes))
				}
				tooltipText={signatureTooltip}
			/>
			<GlassToolbarButton aria-label={ungroupTooltip} onClick={ungroup} tooltipText={ungroupTooltip}>
				<GlassToolbarIcon icon="ungroup" />
			</GlassToolbarButton>
		</>
	);
};

export default GalleryActions;
